import React, { useEffect, useState } from "react";
import "./USDT_Tabs.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faUpload, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  AppSetup,
  GetSigleUSDTWallet,
  GetUSDTWallets,
} from "../../../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";
import { IDS } from "../../../../utils/IDS";
import { Controller, useForm } from "react-hook-form";
import Successfull_strip_modal from "../../../Common/Common_Component/Common_Modal/Successfull_strip_modal/Successfull_strip_modal";
import { GETAuthLogin } from "../../../../features/auth/Slice";
import {
  DepositeAmountWithUSDT,
  GetAllDepositHistory,
} from "../../../../features/wallet/slice";
import Data_Loader from "../../../Common/Common_Component/Data_Loader/Data_Loader";
// import { IDS } from "../../../utils/IDS";

const usdtTabs = [
  {
    id: "bsc",
    title: "BNB Smart Chain",
    shortTitle: "BSC",
    network: "BSC",
  },
  {
    id: "tron",
    title: "Tron Asset",
    shortTitle: "TRC20",
    network: "TRC20",
  },
  {
    id: "solana",
    title: "Solana Asset",
    shortTitle: "SOL",
    network: "SOLANA",
  },
];

function USDT_Tabs() {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    control,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      amount: "",
      remark: "",
      payment_proof: "",
      doller_amount: "",
      transaction_no: "",
    },
  });

  const [activeNetwork, setActiveNetwork] = useState("bsc");
  const [points, setPoints] = useState("");
  const [transactionNo, setTransactionNo] = useState("");
  const [remark, setRemark] = useState("");

  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const handleHistoryClick = () => {
    navigate("/usdt-deposit-history");
  };

  const usdt_wallets = useSelector((state) => state.common.usdt_wallets);
  const single_usdt_wallet = useSelector(
    (state) => state.common.single_usdt_wallet,
  );

  const appSetup = useSelector((state) => state.common.app_setup);

  useEffect(() => {
    dispatch(AppSetup());

    dispatch(GetUSDTWallets());
  }, [dispatch]);

  const handleGetWallet = async (id) => {
    try {
      if (id) await dispatch(GetSigleUSDTWallet(id));
    } catch (error) {
      console.error("handleGetWallet error :", error);
    }
  };

  useEffect(() => {
    if (usdt_wallets?.length > 0 && usdt_wallets?.[0]?.id) {
      handleGetWallet(usdt_wallets?.[0]?.id);
    }
  }, [usdt_wallets]);

  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      if (!single_usdt_wallet?.address) return;
      await navigator.clipboard.writeText(single_usdt_wallet?.address);
      setCopied(true);

      setTimeout(() => {
        setCopied(false);
      }, 2000);
    } catch (error) {
      console.error("Copy failed:", error);
    }
  };
  const doller_amount = watch("doller_amount");
  useEffect(() => {
    if (doller_amount && appSetup?.usd_exchange_rate) {
      setValue("amount", appSetup?.usd_exchange_rate * doller_amount);
    } else {
      setValue("amount", "");
    }
  }, [doller_amount]);

  const [preview, setPreview] = useState(null);

  const handlePayment = async (data) => {
    console.log("FORM DATA:", data);

    console.log("Dollar Amount:", data.doller_amount);
    console.log("Points:", data.amount);
    console.log("Transaction No:", data.transaction_no);
    console.log("Remark:", data.remark);
    console.log("Payment Proof:", data.payment_proof);
    try {
      const formData = new FormData();
      formData.append("amount", data?.amount);
      formData.append("transaction_no", data?.transaction_no);
      if (data?.remark) formData.append("remark", data?.remark);
      formData.append("address_id", single_usdt_wallet?.id);
      if (data?.payment_proof) formData.append("image", data?.payment_proof);

      const res = await dispatch(DepositeAmountWithUSDT(formData));

      if (res.meta?.requestStatus === "fulfilled") {
        // clearForm();
        reset();
        setPreview(null);
        setModalMessage(
          res?.payload?.data || "Deposit request submitted successfully",
        );
        setModalShow(true);
        setTimeout(() => setModalShow(false), 3000);

        await dispatch(GETAuthLogin());
        await dispatch(GetAllDepositHistory());
      } else {
        setModalMessage(
          res?.payload?.errors || "Deposit failed. Please try again",
        );
        setModalShow(true);
        setTimeout(() => setModalShow(false), 3000);
      }
    } catch (error) {
      console.error("Deposit error:", error);
    }
  };
  // if (!single_usdt_wallet?.id) {
  //   return (
  //     <div className="d-flex justify-content-center align-items-center py-5">
  //       <div className="spinner-border text-warning" role="status">
  //         <span className="visually-hidden">Loading...</span>
  //       </div>
  //     </div>
  //   );
  // }
  return (
    <div className="USDT_Tabs">
      <button
        type="button"
        className="usdt_history_btn"
        onClick={handleHistoryClick}
      >
        USDT History
      </button>
      {/* USDT Network Tabs */}
      <div className="usdt_network_tabs">
        {usdt_wallets?.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={`usdt_network_tab ${
              single_usdt_wallet?.id === tab?.id ? "active" : ""
            }`}
            onClick={() => handleGetWallet(tab?.id)}
          >
            <span className="usdt_network_icon">
              <img
                src={IDS.IMG_URL + tab?.icon || ""}
                alt={`${tab?.name}`}
                className="usdt_network_icon"
              />
            </span>

            <span className="usdt_network_text">
              <strong>{tab?.name || ""}</strong>
              <small>{tab?.network || ""}</small>
            </span>
          </button>
        ))}
      </div>

      {/* USDT Content */}
      <div className="usdt_payment_content">
        {/* QR Code */}
        <div className="usdt_qr_wrapper">
          <img
            src={IDS.IMG_URL + single_usdt_wallet?.image || ""}
            alt={`${single_usdt_wallet?.name}`}
            className="usdt_qr"
          />
        </div>

        <p className="usdt_payment_text">
          To make payment, send {single_usdt_wallet?.name} to address below.
        </p>

        {/* Wallet Address */}
        <div className="usdt_address_box">
          <div className="usdt_address_icon">
            {" "}
            <img
              src={IDS.IMG_URL + single_usdt_wallet?.image || ""}
              alt={`${single_usdt_wallet?.name}`}
              className="usdt_network_icon"
            />
          </div>

          <span className="usdt_address">{single_usdt_wallet?.address}</span>

          <button type="button" className="usdt_copy_btn" onClick={handleCopy}>
            <FontAwesomeIcon icon={faCopy} />
            Copy
          </button>

          {copied && (
            <span
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                background: "#000000b9",
                color: "#fff",
                padding: "8px 14px",
                fontSize: "14px",
                borderRadius: "6px",
                zIndex: 9999,
              }}
            >
              Address Copied!
            </span>
          )}
        </div>

        {/* Network */}
        <div className="usdt_network_info">
          <span>NETWORK :</span>
          <strong>{single_usdt_wallet?.network || ""}</strong>
        </div>

        <Form onSubmit={handleSubmit(handlePayment)}>
          {/* Amount */}
          <div className="usdt_field">
            <Form.Control
              type="number"
              min="10"
              max="500000"
              placeholder="ENTER AMOUNT"
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              {...register("doller_amount", {
                required: "Please enter an amount",

                min: {
                  value: 10,
                  message: "Minimum amount is 10",
                },

                max: {
                  value: 500000,
                  message: "Maximum amount is 500000",
                },

                validate: (value) => {
                  const amount = Number(value);

                  if (amount < 0) {
                    return "Amount cannot be negative";
                  }

                  if (amount <= 0) {
                    return "Amount must be greater than 0";
                  }

                  return true;
                },
              })}
            />

            {errors?.doller_amount && (
              <small className="text-danger">
                {errors.doller_amount.message}
              </small>
            )}
          </div>

          {/* Points */}
          <div className="usdt_field">
            <Form.Control
              type="number"
              placeholder="POINTS"
              disabled
              {...register("amount")}
            />

            {errors?.amount && (
              <small className="text-danger">{errors.amount.message}</small>
            )}
          </div>

          {/* Upload Proof */}
          <div className="usdt_upload_wrapper">
            <div className="usdt_upload_wrapper">
              <Controller
                name="payment_proof"
                control={control}
                rules={{
                  required: "Please upload payment proof",

                  validate: {
                    fileType: (file) => {
                      if (!file) {
                        return "Please upload payment proof";
                      }

                      if (!file.type?.startsWith("image/")) {
                        return "Only image files are allowed";
                      }

                      return true;
                    },

                    fileSize: (file) => {
                      if (!file) {
                        return "Please upload payment proof";
                      }

                      const maxSize = 5 * 1024 * 1024; // 5 MB

                      if (file.size > maxSize) {
                        return "Image size must be less than 5 MB";
                      }

                      return true;
                    },
                  },
                }}
                render={({ field }) => (
                  <>
                    <input
                      type="file"
                      id="usdt_payment_proof"
                      hidden
                      accept="image/*"
                      onChange={(e) => {
                        const file = e.target.files?.[0] || null;

                        // Give the actual File to RHF
                        field.onChange(file);

                        // Preview
                        if (file) {
                          setPreview(URL.createObjectURL(file));
                        } else {
                          setPreview(null);
                        }
                      }}
                    />

                    <label
                      htmlFor="usdt_payment_proof"
                      className="usdt_upload_box"
                    >
                      {preview ? (
                        <img
                          src={preview}
                          alt="Payment Proof"
                          className="usdt_uploaded_preview"
                        />
                      ) : (
                        <>
                          <FontAwesomeIcon icon={faUpload} />
                          <span>UPLOAD PAYMENT PROOF</span>
                        </>
                      )}
                    </label>
                  </>
                )}
              />

              {errors?.payment_proof && (
                <small className="text-danger d-block mt-1">
                  {errors.payment_proof.message}
                </small>
              )}
            </div>
          </div>

          {/* Transaction Number */}
          <div className="usdt_field">
            <Form.Control
              type="text"
              placeholder="TRANSACTION NO."
              {...register("transaction_no", {
                required: "Please enter transaction number",

                validate: (value) => {
                  if (!value.trim()) {
                    return "Please enter transaction number";
                  }

                  return true;
                },

                minLength: {
                  value: 3,
                  message: "Transaction number must be at least 3 characters",
                },

                maxLength: {
                  value: 100,
                  message: "Transaction number cannot exceed 100 characters",
                },
              })}
            />

            {errors?.transaction_no && (
              <small className="text-danger">
                {errors.transaction_no.message}
              </small>
            )}
          </div>

          {/* Remark */}
          <div className="usdt_field">
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="REMARK"
              {...register("remark", {
                maxLength: {
                  value: 250,
                  message: "Remark cannot exceed 250 characters",
                },
              })}
            />

            {errors?.remark && (
              <small className="text-danger">{errors.remark.message}</small>
            )}
          </div>

          {/* Information */}
          <div className="usdt_info_box">
            The funds sent will be converted into INR after the transaction is
            confirmed by the blockchain and credited to the balance
            automatically. The transaction confirmation is paid by the user.
          </div>

          {/* Payment Button */}
          <button type="submit" className="usdt_payment_btn">
            {/* <FontAwesomeIcon icon={faArrowUp} /> */}I have made the payment
          </button>
        </Form>
      </div>

      <Successfull_strip_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textMsg={modalMessage}
      />
    </div>
  );
}

export default USDT_Tabs;
